<script>
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let recsStore = getGroupStore('recsStore');

  import Url from '@utils/url';

  import Button from '@components/Button.svelte';
  import BenableLogo from '@components/BenableLogo.svelte';
  import { onMount } from 'svelte';
  import CustomScroll from '@utils/custom-scroll';
  import Rating from '@app-components/rec_object/parts/Rating.svelte';
  import Neighborhood from '@app-components/rec_object/parts/Neighborhood.svelte';
  import Photos from '@app-components/rec_object/parts/Photos.svelte';
  import Review from '@app-components/rec_object/parts/Review.svelte';
  import Comments from '@app-components/comments/Comments.svelte';
  import Like from '@app-components/rec_object/parts/Like.svelte';
  import Categories from '@app-components/rec_object/parts/Categories.svelte';
  import RecObjectOptionMenu from '@app-components/RecObjectOptionMenu.svelte';
  import BookmarkButton from '@app-components/BookmarkButton.svelte';
  import AddComment from '@app-components/comments/AddComment.svelte';
  import { inview } from 'svelte-inview';
  import queryString from 'query-string';

  export let recObject;
  export let close;
  export let goToWeblink;
  export let goToEmail;
  export let goToInstagram;
  export let goToPhone;
  export let copyLink;
  export let showActionBar;
  export let showBookmark;
  export let customGroupStore;

  let group = customGroupStore || groupStore;
  let recs = recsStore.where({ rec_object_id: recObject.id });
  let rec = recs && recs[0];
  let showStepTwoModal = false;
  let focusBrokenLink = false;
  let showWebsiteLink = true;
  const editMode = new URL(location.href).searchParams.has('edit');

  let hasAddress = recObject.addresses && recObject.addresses.length > 0;

  let mobile = true;
  let likes = {};

  let isWeblinkPresent = recObject.weblink && !recObject.hide_weblink;

  let toggleBookmark;
  let bookmark;
  let showAddComment = false;
  $: commentsTotal = recObject.comments && recObject.comments.total && recObject.comments.total;
  $: showBottomBar = isWeblinkPresent;

  $: canEditNote = group && group.permissions.edit;
  $: hasNoteWithContents = recs && recs.filter((r) => r.user_note != '').length > 0;
  $: hasContributors = group && group.users.length > 1;

  $: showReviews = canEditNote || hasNoteWithContents || hasContributors;

  let toggleLike;
  let isCommentEditMode = false;
  if (editMode) {
    setTimeout(() => {
      showStepTwoModal = true;
      focusBrokenLink = true;
    }, 200);
  }

  let handleOverlayClick = function () {
    showWebsiteLink = true;
  };

  onMount(() => {
    let queryParams = queryString.parse(location.search) || {};

    let commentId = queryParams['comment_id'] || queryParams['commentId'];

    if (commentId != null) {
      setTimeout(CustomScroll.scrollToRequiredDivById, 200, `comment-box-${commentId}`);
      commentId = null;
    }
  });
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';
  .detail-mobile-container {
    display: flex;
    flex-direction: column;
    margin: -20px;

    .detail-mobile-photos {
      height: 260px;
      max-height: 260px;
      position: relative;

      .photo {
        height: 260px;
        width: 100%;
        object-fit: cover;

        &.contain {
          object-fit: contain;
          background-color: white;
          border-bottom: 1px solid $neutral-input-gray;
        }
      }
    }

    .back-btn {
      background: transparent;
      position: absolute;
      top: 0px;
      z-index: 2;
      height: 48px;
      width: 48px;
      align-items: center;
      display: flex;
      padding-left: 20px;
    }

    .detail-options-button {
      background: transparent;
      position: absolute;
      top: 0px;
      right: 0px;
      z-index: 11;
      height: 48px;
      width: 48px;
      align-items: center;
      display: flex;
      padding-right: 20px;
    }

    .detail-mobile-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      padding: 20px;
      background: white;
      border-bottom: 6px solid #f5f5f5;
    }

    .detail-mobile-categories {
      font-weight: 500;
      font-size: 16px;
      line-height: 26px;
      padding: 20px;
      background: white;
      border-bottom: 6px solid #f5f5f5;
    }

    .detail-mobile-notes {
      background: white;
      padding: 20px;
      border-bottom: 6px solid #f5f5f5;
    }

    .detail-mobile-rating {
      background: white;
      padding: 15px;
      border-bottom: 6px solid #f5f5f5;
    }

    .detail-mobile-address {
      display: flex;
      padding: 20px;
      border-bottom: 6px solid #f5f5f5;
      background: white;
    }

    .detail-mobile-info {
      display: flex;
      padding: 20px;
      padding-top: 11px;
      padding-bottom: 11px;
      border-bottom: 6px solid #f5f5f5;
      background: white;
      flex-direction: column;

      .detail-contact-single {
        display: flex;
        align-items: center;
        padding-right: 20px;
        margin-right: -20px;
        width: fit-content;
        flex-shrink: 0;
        flex-grow: 0;
        max-width: 100%;
        padding-top: 9px;
        padding-bottom: 9px;

        span {
          margin-left: 14px;
          color: #8e71ff;
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;

          &:hover {
            color: #7054dc;
          }
          &.broken-link {
            color: #ff5567;
            &:focus {
              color: #cc4452;
            }
            &:hover {
              color: #cc4452;
            }
          }
        }
      }
    }

    .detail-mobile-comments {
      padding: 20px;
      padding-bottom: 40px;
      border-bottom: 6px solid #f5f5f5;
      background: white;

      .detail-mobile-comment-label {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #7f7f7f;
      }
    }

    .detail-mobile-actions {
      padding: 20px;
      display: flex;
      gap: 8px;
      border-bottom: 6px solid #f5f5f5;
      background: white;

      .detail-mobile-action-button {
        flex: 1;
        text-align: center;

        .action-btn {
          width: 100%;
          display: flex;
          font-size: 14px;
          font-weight: 500;
          justify-content: center;
          align-items: center;
          border: 2px solid #ececec;
          border-radius: 12px;
          height: 48px;
        }
      }
    }

    .detail-mobile-bottom-bar {
      background: white;
      box-shadow: 0px 8px 50px rgba(0, 0, 0, 0.08);
      position: fixed;
      bottom: 0px;
      width: 100%;
      display: flex;
      padding-left: 12px;
      padding-right: 12px;
      align-items: center;
      padding-top: 5px;
      padding-bottom: 22px;
      z-index: 10;

      .bottom-bar-view-website {
        flex: 1;
      }

      .add-comment-wrapper {
        padding-left: 8px;
        padding-right: 8px;
      }
    }

    .detail-mobile-scrollable {
      overflow-y: scroll;
      padding-bottom: 54px;

      .detail-mobile-topbar {
        height: 59px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        margin-left: 22px;
      }
    }
  }

  * :global(.ui-neighborhood-container) {
    margin-top: 0px !important;
  }

  * :global(.neighborhood-container-inside) {
    align-items: flex-start;
  }

  * :global(.neighborhood-container-inside > svg) {
    margin-top: 6px;
    margin-right: 6px;
  }

  * :global(.ui-save-it) {
    border: 2px solid #ececec !important;
    border-radius: 12px !important;
    height: 48px !important;
  }

  * :global(.ui-rating-container) {
    background: white;
    border-bottom: 6px solid #f5f5f5;
    padding: 20px !important;
  }

  * :global(.rec-object-actions) {
    top: 12px !important;
    right: unset !important;
  }

  * :global(.rec-object-actions svg path) {
    fill: white !important;
  }

  * :global(.rec-object-actions.regular svg) {
    filter: drop-shadow(rgba(0, 0, 0, 0.8) 0px 0px 8px);
  }

  * :global(.review-avatar > img) {
    width: 27px !important;
    height: 27px !important;
  }

  * :global(.ui-note-name-note) {
    padding-top: 0px !important;
    font-size: 16px;
  }

  * :global(.ui-note-description) {
    margin-left: -15px !important;
    font-size: 16px !important;
  }

  * :global(.liked svg) {
    fill: black !important;
  }

  * :global(.add-comment-body) {
    padding-top: 8px !important;
    margin-top: 6px !important;
  }

  .empty-comments-container {
    height: 108px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #808080;
    justify-content: center;
    .message {
      color: var(--purple-text-purple, #5e518e);
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
    }
  }
</style>

<div class="detail-mobile-container" style={showBottomBar ? 'margin-bottom: 72px' : ''}>
  {#if isCommentEditMode}
    <div class="add-comment-edit-mode-overlay" on:click={handleOverlayClick}></div>
  {/if}
  {#if showActionBar}
    <div class="detail-options-button">
      <RecObjectOptionMenu
        customGroupStore={customGroupStore}
        mobile={mobile}
        recObjectId={recObject.id}
        detailsViewOption={false}
        showStepTwoModal={showStepTwoModal}
        focusBrokenLink={focusBrokenLink}
        brokenLinkRelay={recObject.weblink_broken}
        actionStyle="top: {window.detailViewLoadedDirectly ? '68' : '10'}px !important; right: 23px !important;" />
    </div>
  {/if}

  <div class="detail-mobile-scrollable">
    {#if window.detailViewLoadedDirectly}
      <div class="detail-mobile-topbar">
        <BenableLogo mobile={true} />
      </div>
    {/if}

    <div style="position: relative">
      <div class="back-btn" on:click={close}>
        <img src="/images/detail-view/back.svg" style="filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.8));" />
      </div>

      <div class="detail-mobile-photos">
        <Photos
          customGroupStore={customGroupStore}
          mobile={true}
          recObjectId={recObject.id}
          useFancyBox={true}
          viewStyle="grid"
          maxBigDotsShown={7}>
          <svelte:fragment slot="img" let:photo>
            <img class="photo {photo.display_style}" src={photo.view_urls.rect_size || photo.view_urls.full_size} />
          </svelte:fragment>
        </Photos>
      </div>
    </div>

    <div class="detail-mobile-title">{recObject.name1}</div>

    {#if recObject.categories.length > 0}
      <div class="detail-mobile-categories">
        <Categories
          customGroupStore={customGroupStore}
          recObjectId={recObject.id}
          clickable={false}
          mobile={true}
          viewStyle="grid"
          showAll={true} />
      </div>
    {/if}

    {#if group.show_review_sites && showReviews}
      <div class="detail-mobile-notes">
        <Review
          customGroupStore={customGroupStore}
          style="padding: 0px"
          nameDescriptionStyle="margin-left: 10px;"
          descriptionStyle="margin-top: 15px !important;"
          mobile={true}
          alwaysShowReview={false}
          id={rec.id}
          view="detail-view"
          lines={4} />
      </div>
    {/if}

    {#if group.show_review_sites}
      <Rating customGroupStore={customGroupStore} recObjectId={recObject.id} mobile={true} displayStyle="inline" />
    {/if}

    {#if hasAddress}
      <div class="detail-mobile-address">
        <Neighborhood
          customGroupStore={customGroupStore}
          neighborhoodStyle="font-weight: 400; font-size: 16px !important; line-height: 24px !important;"
          showFullAddress={true}
          mobile={true}
          recObjectId={recObject.id} />
      </div>
    {/if}

    {#if isWeblinkPresent || (recObject.instagram_url && recObject.instagram_url != '') || (recObject.email && recObject.email != '') || (recObject.phone && recObject.phone != '')}
      <div class="detail-mobile-info">
        {#if isWeblinkPresent}
          <div class="detail-contact-single detail-url" on:click|preventDefault={goToWeblink}>
            <img
              src={recObject.weblink_broken ? '/images/alert.svg' : '/images/detail-view/link-2.png'}
              style="width: 16px; height: 16px" />
            <span class={recObject.weblink_broken ? 'broken-link' : ''}
              >{Url.urlWithoutHttpsOrWww(recObject.weblink)}</span>
          </div>
        {/if}

        {#if recObject.instagram_url && recObject.instagram_url != ''}
          <div class="detail-contact-single detail-instagram" on:click|preventDefault={goToInstagram}>
            <img src="/images/detail-view/instagram-2.png" style="width: 16px; height: 16px" />
            <span>
              {recObject.instagram_handle || recObject.instagram_url}
            </span>
          </div>
        {/if}

        {#if recObject.email && recObject.email != ''}
          <div class="detail-contact-single detail-email" on:click|preventDefault={goToEmail}>
            <img src="/images/detail-view/email-2.png" style="width: 16px; height: 16px" />
            <span>{recObject.email}</span>
          </div>
        {/if}

        {#if recObject.phone && recObject.phone != ''}
          <div class="detail-contact-single detail-phone" on:click|preventDefault={goToPhone}>
            <img src="/images/detail-view/phone-2.png" style="width: 16px; height: 16px" />
            <span>{recObject.phone}</span>
          </div>
        {/if}
      </div>
    {/if}

    <div class="detail-mobile-actions">
      <div class="detail-mobile-action-button" style="min-width: 93px;">
        <div class="action-btn" on:click={copyLink}>
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.18572 8.09221C1.56444 8.09221 1.87144 8.39922 1.87144 8.77793V11.5108C1.87144 13.2327 3.26731 14.6285 4.98919 14.6285H12.011C13.7329 14.6285 15.1287 13.2327 15.1287 11.5108V8.77793C15.1287 8.39922 15.4357 8.09221 15.8144 8.09221C16.1932 8.09221 16.5002 8.39922 16.5002 8.77793V11.5108C16.5002 13.9901 14.4903 16 12.011 16H4.98919C2.50988 16 0.5 13.9901 0.5 11.5108V8.77793C0.5 8.39922 0.807008 8.09221 1.18572 8.09221Z"
              fill="black" />
            <path
              d="M8.20399 0.0670328C8.29361 0.0240661 8.39402 0 8.50005 0C8.70896 0 8.89604 0.0934162 9.02181 0.240754L13.397 5.08145C13.651 5.36241 13.6291 5.79604 13.3481 6.04998C13.0671 6.30392 12.6335 6.28201 12.3796 6.00106L9.18577 2.46745V8.7783C9.18577 9.15701 8.87877 9.46402 8.50005 9.46402C8.12134 9.46402 7.81433 9.15701 7.81433 8.7783V2.46664L4.6198 6.00106C4.36586 6.28201 3.93224 6.30392 3.65128 6.04998C3.37032 5.79604 3.34842 5.36241 3.60236 5.08145L7.99097 0.225921C8.0516 0.158838 8.12415 0.105189 8.20399 0.0670328Z"
              fill="black" />
          </svg>

          <div style="margin-left: 12px">Share</div>
        </div>
      </div>

      {#if group.show_likes}
        <div class="detail-mobile-action-button" style="min-width: 78px;">
          <div class="action-btn" on:click={toggleLike}>
            <Like
              customGroupStore={customGroupStore}
              style="margin-top: 0px;"
              recObjectId={recObject.id}
              bind:likes={likes}
              bind:toggleLike={toggleLike}
              displayCount={false}
              mobile={true} />
            <div style="margin-left: 12px;">{likes.total && likes.total > 0 ? likes.total : 'Like'}</div>
          </div>
        </div>
      {/if}

      {#if showBookmark}
        <div class="detail-mobile-action-button" style="min-width: 138px;">
          <div class="action-btn" on:click|preventDefault|stopPropagation={toggleBookmark}>
            <div style="display: flex; align-items: center;">
              <BookmarkButton
                rec={rec}
                viewStyle="rec-object-detail"
                bind:toggleBookmark={toggleBookmark}
                mobile={true}
                bind:bookmark={bookmark} />
              <span style="margin-left: 10px;">{bookmark ? 'Bookmarked' : 'Bookmark'}</span>
            </div>
          </div>
        </div>
      {/if}
    </div>

    {#if group.show_comments}
      <div
        class="detail-mobile-comments"
        use:inview={{ rootMargin: '-80px' }}
        on:inview_enter={() => {
          showAddComment = true;
        }}
        on:inview_leave={(event) => {
          const scrollDirection = event.detail.scrollDirection;
          if (scrollDirection && scrollDirection.vertical) {
            showAddComment = scrollDirection.vertical == 'up';
          }
        }}>
        <span class="detail-mobile-comment-label">Comments {`(${commentsTotal || 0})`}</span>
        {#if recObject.comments && recObject.comments.data.length > 0}
          <Comments
            customGroupStore={customGroupStore}
            mobile={mobile}
            viewStyle="detail-view"
            recObjectId={recObject.id} />
        {/if}
        {#if commentsTotal === 0}
          <div class="empty-comments-container">
            <div class="message">🥳 Be the first to comment!</div>
          </div>
        {/if}
      </div>
    {/if}
  </div>

  <div
    class="detail-mobile-bottom-bar"
    style="display: block; padding-top: 15px;"
    class:hidden={!showBottomBar && !showAddComment}>
    <div class="add-comment-wrapper" class:hidden={!showAddComment}>
      <AddComment
        bind:editMode={isCommentEditMode}
        context={'rec'}
        customGroupStore={customGroupStore}
        mobile={true}
        recObjectId={recObject.id}
        on:focus={() => {
          showWebsiteLink = false;
        }}
        on:blur={() => {
          if (!isCommentEditMode) showWebsiteLink = true;
        }} />
    </div>
    {#if showBottomBar && showWebsiteLink}
      <div class="bottom-bar-view-website">
        <Button text="View website" on:click={goToWeblink} />
      </div>
    {/if}
  </div>
</div>
